import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SharedService} from "../../../services/shared.service";
import {UserService} from "../../../services/user.service";
import {Router, ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-commerce',
  templateUrl: './commerce.component.html',
  styleUrls: ['./commerce.component.scss']
})
export class CommerceComponent implements OnInit {
  selectedPage = 'quoteRequests';
  isSelected = false;

  constructor(private sharedService: SharedService,
    private userService: UserService,
    private route: ActivatedRoute) {
    this.userService.handleCommerceNavEvent()
      .subscribe(res => {
        this.updateSelectedPage();
      });
  }

  ngOnInit() {
    this.commerceActivities();
  }

  updateSelectedPage() {
    if (this.route.snapshot.queryParams.activity) {
      this.selectedPage = this.route.snapshot.queryParams.activity;
    }
  }

  commerceActivities() {
    if (this.route.snapshot.queryParams.activity) {
      this.selectedPage = this.route.snapshot.queryParams.activity;
    } else {
      this.selectedPage = this.sharedService.getSelectedTab();
    }
    if (this.selectedPage == 'quoteRequests') {
      this.setParamToDisplayData('rfq');
      this.sharedService.rfq = 'rfq';
    } else if (this.selectedPage == 'buyerQuoteRequests') {
      this.setParamToDisplayData('buyerRfq');
      this.sharedService.rfq = 'buyerRfq';
    } else if (this.selectedPage == 'leadRegistration') {
      this.setParamToDisplayData('lead');
      this.sharedService.rfq = 'lead';
    }
  }

  setParamToDisplayData(requestType) {
    const self = this;
    setTimeout(function () {
      self.sharedService.rfqSubject.next({
        'displayStatus': false,
        'requestType': requestType,
        'isSelected': self.isSelected
      });

    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/commerce/commerce.component.ts